import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import './Legal.css'

export default function ShippingPolicy() {
  return (
    <div className="legal-page">
      <Header />
      
      <main className="legal-content">
        <div className="container">
          <Link to="/" className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          
          <div className="legal-card">
            <h1>Shipping & Delivery Policy</h1>
            <p className="legal-date">Last updated: December 2024</p>
            
            <section className="legal-section">
              <h2>Digital Products Only</h2>
              <p>
                <strong>Digital vCard</strong> is a 100% digital service. We do not sell or 
                ship any physical products. All our services are delivered electronically.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>Instant Digital Delivery</h2>
              <p>
                Upon successful payment and account creation, you will receive immediate 
                access to:
              </p>
              <ul>
                <li>Your personalized digital vCard profile</li>
                <li>Unique shareable link (e.g., vcard-bdd.pages.dev/v/yourname)</li>
                <li>Downloadable QR code</li>
                <li>Access to your dashboard for editing and analytics</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>Delivery Timeline</h2>
              <div className="policy-highlight">
                <p>
                  <strong>Instant Access:</strong> All digital services are delivered 
                  immediately after successful payment. No waiting period required.
                </p>
              </div>
            </section>
            
            <section className="legal-section">
              <h2>Access Your Services</h2>
              <p>
                After purchase, you can access your digital vCard services by:
              </p>
              <ul>
                <li>Logging into your dashboard at our website</li>
                <li>Using the confirmation email sent to your registered email address</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>No Physical Shipping</h2>
              <p>
                Since all our products are digital, there are no shipping charges, 
                delivery delays, or physical tracking involved. Your vCard is ready 
                to use the moment you complete your purchase.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>Contact Us</h2>
              <p>
                If you face any issues accessing your digital services after payment, 
                please contact us immediately:
              </p>
              <ul className="contact-list">
                <li>Email: support@santhoshsharuk.me</li>
                <li>Phone: +91 81109 60489</li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  )
}
